module.exports = __webpack_public_path__ + "static/media/123banklogo.bc993e00.png";